import {PropsWithChildren, useEffect} from "react";
import {PubSub} from "../utility/PubSub";
import {AnalyticsEventData, AnalyticsPayload} from "./Analytics";
import {useRecoilValue} from "recoil";
import {AccessContextData} from "../providers/access/AppContextProvider";
import {AppDataAtom} from "../providers/access/ApplicationDataProvider";
import ReactGA4 from "react-ga4";
import ReactGA from "react-ga";

export const AnalyticsProvider = ({children}: PropsWithChildren<any>) => {
   const appContext = useRecoilValue(AccessContextData);
   const appData = useRecoilValue(AppDataAtom);

   useEffect(() => {
      if (appData?.gaTrackingId || appData?.uaTrackingId) {
         PubSub.on('analytics', (data: AnalyticsPayload) => {
            const staticData = AnalyticsEventData[data.event]

            if (appData?.gaTrackingId) {
               const ga4payload = {
                  ...data.data,
                  event: data.event,
                  area: staticData?.category,
                  shopId: appContext.shopId,
                  locale: appContext.locale,
                  currency: appContext.currency,
                  consumerId: appContext.consumerId,
                  wholeSaleActive: appContext.wholeSaleActive,
                  allowedCountry: appContext.allowedCountry,
               };
               try {
                  ReactGA4.event({
                     action: data.event,
                     category: staticData?.category || 'Unknown'
                  }, ga4payload);
                  console.debug('GA4 Event', ga4payload)
               } catch (e) {
                  console.error('GA4 Event failed', ga4payload, e)
               }
            }

            if (appData?.uaTrackingId) {
               const uaPayload = {
                  category: staticData?.category || 'Unknown',
                  action: data.event,
                  nonInteraction: true
               };
               try {
                  ReactGA.event(uaPayload, ['create2STAY']);
                  console.debug('UA Event', uaPayload)
               } catch (e) {
                  console.error('UA Event failed', uaPayload, e);
               }
            }
         })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [appData?.gaTrackingId, appData?.uaTrackingId])

   return children
}